import React, { useState, useEffect, useRef } from "react";

// Imports
import TitleText from "./TitleText";
import { useNavigate } from "react-router-dom";

const whyChooseData = [
  {
    img: "/assets/top-quality-standards.png",
    title: "Top-Quality Labs",
    descLine1: "India's top 5 labs",
  },
  {
    img: "/assets/money-back-guarantee.png",
    title: "100% Money Back*",
    descLine1: "view info",
  },
  {
    img: "/assets/affordable-packages.png",
    title: "Affordable Pricing",
    descLine1: "with great offers",
  },
  {
    img: "/assets/quick-delivery.png",
    title: "Quick Report Delivery",
    descLine1: "Across all India",
  },
  {
    img: "/assets/seamless-experience.png",
    title: "Free Home Collection",
    descLine1: "Use Promocode in cart",
  },
  {
    img: "/assets/expert-care.png",
    title: "Expert Care",
    descLine1: "Call 9138923900",
  },
];

const WhyChoose = ({isScrollable=false}) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const autoScrollInterval = useRef(null);

  // Auto-scroll functionality
  useEffect(() => {
    if (isScrollable) {
      autoScrollInterval.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % whyChooseData.length;
          return nextIndex;
        });
      }, 3000); // 10 seconds

      return () => {
        if (autoScrollInterval.current) {
          clearInterval(autoScrollInterval.current);
        }
      };
    }
  }, [isScrollable]);

  // Scroll to current item
  useEffect(() => {
    if (isScrollable && scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const itemWidth = 350 + 20; // item width + gap
      container.scrollTo({
        left: currentIndex * itemWidth,
        behavior: 'smooth'
      });
    }
  }, [currentIndex, isScrollable]);

  // Touch handlers for swipe
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    
    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentIndex < whyChooseData.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
    if (isRightSwipe && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }

    // Reset auto-scroll timer when user interacts
    if (autoScrollInterval.current) {
      clearInterval(autoScrollInterval.current);
      autoScrollInterval.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % whyChooseData.length);
      }, 10000);
    }
  };

  return (
    <>
      {/* Large Screens */}
      <div className="w-full h-fit text-center hidden lg:flex lg:flex-col justify-start items-center space-y-[3%]">
        <span className="font-semibold w-3/4 text-lg text-center sm:text-[22px] lg:text-[24px] text-textPrimaryColor">
            Why Choose Fine Labs?
        </span>
        <div className="w-full h-fit flex flex-wrap justify-between items-center">
          {whyChooseData?.slice(0, 3).map((item, index) => (
            <div
              className="bg-[#F7F7F7] rounded-[24px] flex justify-start pl-[2%] items-center space-x-4 w-[356px] h-[128px]"
              key={index}
            >
              <img src={item?.img} alt="icon" className="mb-[3%] w-[80px] h-[80px]" />
              <div className="flex flex-col items-start">
                <p className="font-semibold text-[16px] text-textPrimaryColor mb-[1%]">
                {item?.title}
              </p>
              {item?.descLine1 === "view info" ? (
                <p className="font-normal text-[0.9vw] text-[#0047AF] underline cursor-pointer" onClick={()=>navigate("/contact-us")}>
                {item?.descLine1}
              </p>
              ):(
                <p className="font-normal text-[0.9vw] text-textSecondaryColor">
                {item?.descLine1}
              </p>
              )}
              </div>
            </div>
          ))}
        </div>
        <div className="w-full h-fit flex flex-wrap justify-between items-center">
          {whyChooseData?.slice(3).map((item, index) => (
            <div
              className="bg-[#F7F7F7] rounded-[24px] flex justify-start pl-[2%] items-center space-x-4 w-[356px] h-[128px]"
              key={index}
            >
              <img src={item?.img} alt="icon" className="mb-[3%] w-[80px] h-[80px]" />
              <div className="flex flex-col items-start">
                <p className="font-semibold text-[16px] text-textPrimaryColor mb-[1%]">
                {item?.title}
              </p>
              <p className="font-normal text-[0.9vw] text-textSecondaryColor">
                {item?.descLine1}
              </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Small Screens */}
      {isScrollable ? (
        <div className="w-full h-fit flex flex-col justify-start items-center space-y-[5%] lg:hidden">
          <TitleText text="Why Choose Fine Labs?" />
          <div className="w-full relative">
            <div 
              ref={scrollContainerRef}
              className="w-full h-fit flex overflow-x-auto scrollbar-hide gap-5 px-4"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {whyChooseData?.map((item, index) => (
                <div
                  className="bg-[#F7F7F7] rounded-[24px] flex justify-start pl-[5%] items-center space-x-4 min-w-[350px] h-[128px] flex-shrink-0"
                  key={index}
                >
                  <img src={item?.img} alt="icon" className="mb-[3%] w-[80px] h-[80px]" />
                  <div className="flex flex-col items-start">
                    <p className="font-semibold text-[16px] text-textPrimaryColor mb-[1%]">
                      {item?.title}
                    </p>
                    {item?.descLine1 === "view info" ? (
                      <p className="font-normal text-[16px] text-[#0047AF] underline cursor-pointer" onClick={()=>navigate("/contact-us")}>
                        {item?.descLine1}
                      </p>
                    ):(
                      <p className="font-normal text-[16px] text-textSecondaryColor">
                        {item?.descLine1}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            
            {/* Pagination dots */}
            <div className="flex justify-center mt-4 space-x-2">
              {whyChooseData.map((_, index) => (
                <button
                  key={index}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentIndex ? 'bg-[#0047AF]' : 'bg-gray-300'
                  }`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-fit flex flex-col justify-start items-center space-y-[5%] lg:hidden">
          <TitleText text="Why Choose Fine Labs?" />
          <div className="w-full h-fit flex flex-col justify-start items-center space-y-[5%]">
            {whyChooseData?.map((item, index) => (
              <div
                className="bg-[#F7F7F7] rounded-[24px] flex justify-start pl-[2%] items-center space-x-4 w-[356px] h-[128px]"
                key={index}
              >
                <img src={item?.img} alt="icon" className="mb-[3%] w-[80px] h-[80px]" />
                <div className="flex flex-col items-start">
                  <p className="font-semibold text-[16px] text-textPrimaryColor mb-[1%]">
                    {item?.title}
                  </p>
                  <p className="font-normal text-[16px] text-textSecondaryColor">
                    {item?.descLine1}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default WhyChoose;